/*
 * Ori Ambient Light Background
 * Tracks pointer position and smoothly lerps a CSS variable pair
 * (--light-x / --light-y) on the .ori-light-bg element so the two
 * radial gradients follow the cursor with a soft trailing feel.
 *
 * - rAF-driven (no jitter on high-refresh displays)
 * - Lerp factor ~0.08 per frame → trailing delay, not sticky
 * - Respects prefers-reduced-motion (bails out, gradients stay static)
 * - Hides itself if pointer leaves the viewport
 */
(function () {
  if (typeof window === 'undefined') return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced && reduced.matches) return;

  function init() {
    var el = document.querySelector('.ori-light-bg');
    if (!el) return;

    /* Current (rendered) position and target (pointer) position, in viewport percent. */
    var cx = 50, cy = 30;
    var tx = 50, ty = 30;
    var running = false;

    function frame() {
      /* Lerp toward target with an 8% step per frame. */
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;

      el.style.setProperty('--light-x', cx.toFixed(2) + '%');
      el.style.setProperty('--light-y', cy.toFixed(2) + '%');

      /* Continue the RAF loop while we're still meaningfully far from the target. */
      if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) {
        requestAnimationFrame(frame);
      } else {
        running = false;
      }
    }

    function start() {
      if (running) return;
      running = true;
      requestAnimationFrame(frame);
    }

    window.addEventListener('pointermove', function (e) {
      tx = (e.clientX / window.innerWidth) * 100;
      ty = (e.clientY / window.innerHeight) * 100;
      start();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
